import { apiUrl } from 'src/config';
import { AuthTokenService, HttpService } from 'src/services';

export type PlayLogEntityType = 'session' | 'challenge-session';

export interface PlayLogProgressData {
  watchSeconds?: number;
  maxPercent?: number;
  completed?: boolean;
  endedAt?: string;
}

const PlayLogService = {
  create: (
    entityId: string,
    entityType: PlayLogEntityType,
    totalSeconds?: number,
  ): Promise<{ id: string }> =>
    HttpService.post('/public/events/play-log', { entityId, entityType, totalSeconds }),

  update: (playLogId: string, data: PlayLogProgressData): Promise<void> =>
    HttpService.patch(`/public/events/play-log/${playLogId}`, data),

  // Fire-and-forget update for page unload (tab close, refresh): a regular
  // XHR can be aborted by the browser mid-unload, `keepalive` cannot.
  // sendBeacon is not an option here — the endpoint needs the Bearer header.
  flush: (playLogId: string, data: PlayLogProgressData): void => {
    const token = AuthTokenService.get();
    fetch(`${apiUrl.replace(/\/+$/, '')}/public/events/play-log/${playLogId}`, {
      method: 'PATCH',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify(data),
    }).catch(() => {});
  },
};

export default PlayLogService;
